<template lang="pug">
  .gvl-disabled
    p GVL_ANTRAG_DISABLED

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({
})
export default class Contact extends Vue {

}
</script>
